import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';
import { getUser, GetWarehouseAddress, sc } from 'src/utils/Common';
import { TableCell } from '@material-ui/core';

function AddressSearch({ setAdres, value,defaultValue, searchParam,MaterialCode, ServicePaperNr, index, Adres, RowSelected, Tip }) {
  const [openAD, setOpenAD] = React.useState(false);
  const [optionsAD, setOptionsAD] = React.useState([]);
  const loadingAD = openAD && optionsAD.length === 0;
  const [searchAD, setSearchAD] = React.useState('');
  const user = getUser();

  // if (Adres === 0) {
  //   var DegerWarehouseAddressKontrol = GetWarehouseAddress(user.ServiceShopId);
  //   var MalzemeDefaultValue = DegerWarehouseAddressKontrol.filter(item =>
  //     sc(item.Materials, MaterialCode)
  //   );  
  //   if (MalzemeDefaultValue.length > 0) {
  //     value = MalzemeDefaultValue[0];
  //     setAdres(value, index, MaterialCode);
  //   }
  // } else {     
  //   if (value.Description === "Adres Seçiniz!...") {
  //     var DegerWarehouseAddressKontrol1 = GetWarehouseAddress(user.ServiceShopId);
  //     var MalzemeDefaultValueKontrol = DegerWarehouseAddressKontrol1.filter(item => parseInt(item.Id) === parseInt(Adres));
  //     value = MalzemeDefaultValueKontrol[0];        
  //     setAdres(value, index, MaterialCode);
  //   }
  // }



  React.useEffect(() => {
    
    let activeAD = true;
    if (openAD) {
      if (activeAD) {             
        if (searchAD.length > 0){
          var DegerWarehouseAddress = GetWarehouseAddress(user.ServiceShopId).filter(item =>
            sc(item.Description, searchAD)
          );
        }
        else{
          var DegerWarehouseAddress = [];
        }             
        var WarehouseCombo = DegerWarehouseAddress.map(item =>
          (item.Materials.indexOf(MaterialCode) !== -1)
            ? { ...item, GroupAddress: 'Malzemenin Adresleri' }
            : { ...item, GroupAddress: 'Diger Adresler' });

        if (Tip === 'Cikis') {
          setOptionsAD(WarehouseCombo.filter(item => item.GroupAddress === 'Malzemenin Adresleri').sort(
            (a, b) => +b.GroupAddress.localeCompare(a.GroupAddress)
          ));
        } else {
          setOptionsAD(WarehouseCombo.sort(
            (a, b) => +b.GroupAddress.localeCompare(a.GroupAddress)
          ));
        }


      }

    }
    return () => {
      activeAD = false;
    };
  }, [searchAD, openAD, loadingAD, MaterialCode]);

  React.useEffect(() => {
    if (searchParam.length > 0) {
      setSearchAD(searchParam);
    }
  }, [searchParam]);
  const updateModel = model => {
    setAdres(model, index, MaterialCode);
    value.Id = model.Id;
    value.Description = model.Description;
    value.Materials = model.Materials;
  }

  return (   
      <Autocomplete
        style={{ width: 200 }}
        open={openAD}
        value={value}
        disabled={RowSelected === 0}
        onOpen={() => {
          setOpenAD(true);
        }}
        onClose={() => {
          setOpenAD(false);
        }}
        getOptionLabel={(option) => { return option.Description }}
        options={optionsAD}
        groupBy={(option) => { return option.GroupAddress }}
        filterOptions={(optionsAD, state) => optionsAD}
        loading={loadingAD}
        onChange={(event, newValue) => {
          if (newValue && newValue.Description) {
            updateModel(newValue, index);
          }
        }}

        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            onChange={e => setSearchAD(e.target.value)}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingAD ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
  );
}

export default AddressSearch;
